import { customScrollbar, focusOutlinesStyles } from 'lib/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledCustomScrollbarWrapper = styled.div`
  ${customScrollbar};
  background-color: ${({ theme }) => theme.color.additional.light.value};
  color: ${({ theme }) => theme.color.additional.dark.value};
`;

const StyledCustomScrollbarWrapperWithFocus = styled.div.attrs({ tabIndex: 0 })`
  ${customScrollbar};
  background-color: ${({ theme }) => theme.color.additional.light.value};
  color: ${({ theme }) => theme.color.additional.dark.value};
  :focus {
    outline: none;
    ${focusOutlinesStyles.primary};
  }
`;

export const CustomScrollbarWrapper = ({ children, className, dataTestId = '', isFocusable = false, ...other }) =>
  isFocusable ? (
    <StyledCustomScrollbarWrapperWithFocus data-testid={dataTestId} {...{ className, isFocusable }} {...other}>
      {children}
    </StyledCustomScrollbarWrapperWithFocus>
  ) : (
    <StyledCustomScrollbarWrapper data-testid={dataTestId} {...{ className, isFocusable }} {...other}>
      {children}
    </StyledCustomScrollbarWrapper>
  );

CustomScrollbarWrapper.propTypes = {
  /** Any content inserted between the tags */
  children: PropTypes.node.isRequired,
  /** Adds additional class to the component */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** If true, the div is focusable, keyboard scrollable and inherits RDS focusable styles */
  isFocusable: PropTypes.bool,
};
